import classnames from 'classnames';
import { SimpleImage } from '@components/common/SimpleImage';
import { ButtonClose } from '@features/Unsubscribe/components/ButtonClose';
import { ButtonGroup } from '@features/Unsubscribe/components/ButtonGroup';
import { Container } from '@features/Unsubscribe/components/Container';
import { Title } from '@features/Unsubscribe/components/Title';
import { useUnsubscribeAnalytics } from '@features/Unsubscribe/hooks/use-unsubscribe-analytics';
import type { TpWizardSteps } from '@features/Unsubscribe/types';
import styles from './Freezed.module.scss';
export const Freezed = (_props: TpWizardSteps) => {
  const {
    defaultEventOptions
  } = useUnsubscribeAnalytics();
  return <Container className={styles.container} eventOnMounted="cancel_freeze_activated_opened" eventOptions={defaultEventOptions} data-sentry-element="Container" data-sentry-component="Freezed" data-sentry-source-file="index.tsx">
      <div className={classnames('double-grow', styles.content)}>
        <SimpleImage src="cancelling-freezed.svg" width="129" height="128" alt="cancelling" data-sentry-element="SimpleImage" data-sentry-source-file="index.tsx" />
        <Title className={styles.title} data-sentry-element="Title" data-sentry-source-file="index.tsx">Your subscription is freezed</Title>
        <p className={styles.description}>
          You can use the app until the end of the current subscription period.
          After that, your subscription will be on hold for two months, then it
          will renew automatically
        </p>
      </div>
      <ButtonGroup data-sentry-element="ButtonGroup" data-sentry-source-file="index.tsx">
        <ButtonClose eventName="cancel_freeze_activated_done_tapped" data-sentry-element="ButtonClose" data-sentry-source-file="index.tsx" />
      </ButtonGroup>
    </Container>;
};